import React, { useEffect, useMemo } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { useUserPreferences } from '../../contexts/UserContext';
import { applyThemeToDocument, resolveActiveTheme } from '../../utils/themePreference';

export interface DesignThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Wires user theme preference to document tokens (data-theme) and Ant Design algorithms.
 */
export function DesignThemeProvider({ children }: DesignThemeProviderProps) {
  const { preferences } = useUserPreferences();
  const theme = useMemo(
    () => resolveActiveTheme(preferences.theme),
    [preferences.theme]
  );

  useEffect(() => {
    applyThemeToDocument(theme);
  }, [theme]);

  return (
    <ConfigProvider
      theme={{
        algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#0066ff',
          borderRadius: 8,
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
